// GTMNoScript.tsx
import { useEffect } from "react";

export default function GTMNoScript() {
    useEffect(() => {
        const ns = document.createElement("noscript");
        ns.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5NR343H3"
              height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `.trim();
        document.body.insertBefore(ns, document.body.firstChild);
        return () => { try { document.body.removeChild(ns); } catch { } };
    }, []);
    return null;
}
